import { gql } from "@apollo/client";
import client from "@services/apolloClient";

export const FIND_VARIANT_DETAILS_PRICE = gql`
  query FindModelDetails($slug: String!, $cityName: String!) {
    findModelDetails(slug: $slug, cityName: $cityName) {
      allVariantSlugs {
        uniqueSortedVariants {
          variantName
          fuelType
          engine
          emission
          transmission
          slug
          marketPrice
          adspPrice
          ackoDriveSavings
          exShowRoomPrice
          onRoadPrice
          featureItemDtos {
            name
            description
            value
          }
          mileage {
            value
            unit
          }
        }
      }
    }
  }
`;

export async function fetchVariantDetailsPrice(slug: string, cityName: string) {
  try {
    const { data } = await client.query({
      query: FIND_VARIANT_DETAILS_PRICE,
      variables: { slug, cityName },
    });
    return data?.findModelDetails?.allVariantSlugs?.uniqueSortedVariants || [];
  } catch (error: any) {
    console.error("Error fetching variant details price:", error?.message);
    return [];
  }
}
